/* Ott-common */
import { ClientType } from '@dtvgo/backend-service/normalize';
import { MsToWaitOnReconnection, Platform } from '../../constants';

/* Utils */
import { initCursorStateListeners } from './cursorState';
import { loadDrmAgent, unloadDrmAgent } from './drmAgent';
import {
  sendAppToBackground,
  getDeviceInfo,
  getTimezone,
  addApis,
  isWebOS,
  getAppId,
  getConnectionStatus,
  getUrlToOpen,
  addRelaunchEventListener,
} from './general';

const KEY_BOARD_STATE_CHANGE_EVENT = 'keyboardStateChange';
function init(onError) {
  addApis();
  window.addEventListener('load', () => { loadDrmAgent(undefined, onError); });
  window.addEventListener('unload', () => { unloadDrmAgent(); });
  initCursorStateListeners();
}

export default {
  osName: 'webOS',
  platformName: 'WebOS',
  isWebOS: true,
  signupUrl: '/lg',
  appName: 'lg_tv',
  isThisPlatform: isWebOS,
  init,
  // App and device info
  clientType: ClientType.LG,
  getAppId,
  getDeviceInfo,
  getTimezone,
  getUrlToOpen,
  // Functions
  sendAppToBackground,
  getConnectionStatus,
  msToWaitOnReconnection: MsToWaitOnReconnection[Platform.WEBOS],
  // Player related options
  isPlayreadyUtf8AndPlain: true,
  loadDrmAgent,
  // Conviva
  npaw: {
    name: 'LG',
  },
  // Keyboard state change
  addKeyboardStateChangeListener: (listener) => {
    const handleEvent = ({ detail: { visibility } }) => {
      listener(visibility);
    };
    document.addEventListener(KEY_BOARD_STATE_CHANGE_EVENT, handleEvent);
    return () => {
      document.removeEventListener(KEY_BOARD_STATE_CHANGE_EVENT, handleEvent);
    };
  },
  addRelaunchEventListener,
  getAppVersion: () => '',
};
